import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "cash-in-out"
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between"
  }
};
var _hoisted_3 = {
  style: {
    "width": "100%",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};
var _hoisted_4 = {
  style: {
    "margin-top": "20px",
    "margin-bottom": "20px"
  }
};
var _hoisted_5 = {
  class: "mt-1"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  style: {
    "display": "flex",
    "flex-direction": "row"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.dialogFormVisible = $event;
    }),
    title: "Cash In/Out",
    "show-close": false,
    width: "25%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        onClick: _ctx.closeModal,
        style: {
          "width": "33%",
          "height": "35px"
        },
        class: "green-plain"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        disabled: !_ctx.canConfirm,
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _ctx.submit,
        style: {
          "width": "66%",
          "height": "35px"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.t("cashfloat.submit")), 1)];
        }),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        onClick: _ctx.cashInType,
        class: _normalizeClass({
          'green-plain': _ctx.isCashIn
        }),
        style: {
          "width": "46%"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.t("cashfloat.cash-in")), 1)];
        }),
        _: 1
      }, 8, ["onClick", "class"]), _createVNode(_component_el_button, {
        onClick: _ctx.cashOutType,
        class: _normalizeClass({
          'green-plain': _ctx.isCashOut
        }),
        style: {
          "width": "46%"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.t("cashfloat.cash-out")), 1)];
        }),
        _: 1
      }, 8, ["onClick", "class"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.cash-value")), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: _ctx.amount,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.amount = $event;
        }),
        class: "input-with-select",
        type: "number",
        onFocus: _ctx.handleInputFocus,
        onBlur: _ctx.handleInputBlur
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _ctx.currency,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.currency = $event;
            }),
            placeholder: "Select",
            style: {
              "width": "115px"
            }
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupCurrencies, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.label,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue", "onFocus", "onBlur"])])]), _createElementVNode("div", null, [_ctx.isCashOut ? (_openBlock(), _createElementBlock("p", _hoisted_6, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.to")), 1)])) : _createCommentVNode("", true), _ctx.isCashIn ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.from")), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_select, {
        modelValue: _ctx.locationId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.locationId = $event;
        }),
        placeholder: _ctx.$t('location'),
        style: {
          "width": "100%"
        },
        class: "mt-1"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: Number(item.id),
              label: String(item.name),
              value: Number(item.id)
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue", "placeholder"])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}